app.controller('paymentDeclineController', ['$scope', '$location', '$cookies', function ($scope, $location, $cookies) {
    if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || $cookies.get('_trns') == undefined) {
        $cookies.remove('_trns', { path: '/' });
        $location.path('/login');
        return;
    }

    $scope.eSpectraCCAmt = $cookies.get('_trns');
    $cookies.remove('_trns', { path: '/' });

}]);